import { clsx } from 'clsx';
import * as styles from './SocialsBlock.css';
import { SOB_SOCIALS_LINKS, SOCIALS_LINKS } from 'shared/constants/socials';
import { useDeviceType } from '@cian/ui-kit';
import { BlueBanner } from '../BlueBanner';
import { useSelector } from 'react-redux';
import { selectDealType } from 'shared/selectors/dealType';
import { selectOfferType } from 'shared/selectors/offerType';
import { EDealType, EOfferType } from 'shared/types/wantType';
import { PIK_RENT, SELECTION_REALTOR } from 'shared/constants/links';

export const SocialsBlock: React.FC = () => {
  const device = useDeviceType();

  const dealType = useSelector(selectDealType);

  const offerType = useSelector(selectOfferType);

  const socials = dealType === EDealType.Host ? SOCIALS_LINKS : SOB_SOCIALS_LINKS;

  const secondBanner =
    dealType === EDealType.Rent && offerType === EOfferType.Apartment
      ? {
          title: 'Сдайте квартиру с Циан х ПИК-Аренда',
          linkBtn: { url: PIK_RENT, text: 'Подробнее' },
          imageClass: 'keys',
        }
      : undefined;

  const mainBanner =
    dealType === EDealType.Host
      ? {
          title: 'Размещайтесь бесплатно и зарабатывайте на посуточной аренде',
          linkBtn: { url: 'https://promo.cian.site/online_booking', text: 'Как это работает' },
          imageClass: 'chair',
        }
      : {
          title: 'Нужна помощь профессионала?',
          linkBtn: { url: SELECTION_REALTOR, text: 'Обратитесь к риелтору' },
          imageClass: 'house',
        };

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['banner-container']}>
        <BlueBanner mainBanner={mainBanner} secondBanner={secondBanner} />
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>Подписывайтесь на&nbsp;наши соцсети </div>
        <div className={styles['list']}>
          {socials.map(({ id, url }) => (
            <a key={id} href={url} target="_blank" className={clsx(styles['icon'], styles[id])} rel="noreferrer" />
          ))}
        </div>
      </div>
    </div>
  );
};
